import * as PopupTracker from "./popupTracker";
import { track } from "../../tracker/EventTracker";
import { NewsletterPopupDialog } from "./PopupDialog";

const VISIT_THRESHOLD = 2;
const POPUP_SHOW_PERIOD = 7 * 24 * 60 * 60 * 1000;
const POPUP_SHOW_PERIOD_LIMIT = 2;

let dialog;
function getDialog() {
	if (!dialog) {
		dialog = new NewsletterPopupDialog();
	}
	return dialog;
}

export async function show() {
	// Do not show to customers which already have signed up
	if (PopupTracker.hasSignedUp()) {
		return false;
	}

	// Show not before some pages have been visited
	if (PopupTracker.getPagesVisited() < VISIT_THRESHOLD) {
		return false;
	}

	// Show only once per day
	if (PopupTracker.getNumberOfPopupShowTimestamps() >= 0) {
		let now = new Date();
		let lastShow = new Date(PopupTracker.getLastPopupShowTimestamp());
		if (
			lastShow.getFullYear() == now.getFullYear() &&
			lastShow.getMonth() == now.getMonth() &&
			lastShow.getDate() == now.getDate()
		) {
			return false;
		}
	}

	// Show only a limited number in a period
	if (
		PopupTracker.getNumberOfPopupShowTimestamps() >= POPUP_SHOW_PERIOD_LIMIT
	) {
		if (
			Date.now() - PopupTracker.getFirstPopupShowTimestamp() <
				POPUP_SHOW_PERIOD &&
			Date.now() - PopupTracker.getLastPopupShowTimestamp() < POPUP_SHOW_PERIOD
		) {
			return false;
		}
	}

	// Load popup contents from the backend.
	const url = new URL(window.location);
	url.pathname = "/newsletter-popup";
	const response = await fetch(url);
	if (!response.ok) {
		return false;
	}

	const popupPayload = await response.json();
	getDialog().show(popupPayload);

	PopupTracker.addPopupShownTimestamp(POPUP_SHOW_PERIOD_LIMIT);
	track("Newsletter", "Anzeige PopUp");

	return true;
}
